export default (() => {
  const overlay = $('#overlay-menu')
  const hamburger = $('#overlay-menu-toggle')
  
  hamburger.on('click', function() {
    $(this).toggleClass('is-active');
    $('body').toggleClass('locked');
    overlay.toggleClass('active');
  });
})();


// WEBPACK FOOTER //
// ./scripts/layout/overlay-menu.js